jQuery(document).ready(function($){
  $('body')
  .on('click', '.codmw2__banner-button', (event) => {
    var $video = $('.codmw2__banner-video');

    if ( $video.length ) {
      event.preventDefault();

      $('body').addClass('codmw2__banner-video__active');
      $video.addClass('is-shown');
    }
  })
  .on('click', '.codmw2__banner-video svg', (event) => {
    event.preventDefault();

    $('body').removeClass('codmw2__banner-video__active');
    $('.codmw2__banner-video').removeClass('is-shown');
    $('.codmw2__banner-video iframe').attr("src", $('.codmw2__banner-video iframe').attr("src"));
  })

  document.querySelectorAll(".codemw2__components-block-slider.swiper").forEach((genreItem, index) => {
    new Swiper(genreItem, {
      // Optional parameters
      loop: false,
      allowTouchMove: false,
    
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    }); 
  });
});